import { UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { endPointUrls } from 'core/constants/endPointUrls';
import api from 'core/services/fetch-api/useApi';
import { useDispatch } from 'react-redux';
import useMutationHook from '../masterQuery/useMutationHook';
import toastHandler from 'core/helpers/toast/toast';
import { setApiCatcherFormErrors } from 'core/store/slice/mainInfo/mainInfoSlice';
import { AxiosResponse } from 'axios';
import { useProductsList } from './products';
import { objectToFormData } from 'core/helpers/form';

export const useImageUpload = () => {
	const dispatch = useDispatch();
	const queryClient = useQueryClient();

	return useMutationHook(
		[endPointUrls.ADMIN_IMAGE_UPLOAD],
		(data: any) => api.post(endPointUrls.ADMIN_IMAGE_UPLOAD, objectToFormData(data)),
		{
			onSuccess: (res) => {
				const response = res as AxiosResponse;

				if (response?.status === 200) {
					toastHandler('success', response?.data.message);
					// queryClient.invalidateQueries([endPointUrls.PROFILE_MANAGEMENT]);

					dispatch(setApiCatcherFormErrors([]));
				}
			},
		}
	) as UseMutationResult;
};
